export const STATUS_AKTIF = 11
export const STATUS_NONAKTIF = 12
export const STATUS_PENDING = 13
export const STATUS_REJECT = 14
export const STATUS_BLOKIR = 15

export const STATUS_AJUAN = {
  3: {
    label: 'Baru',
    color: 'grey'
  },
  4: {
    label: 'Menunggu',
    color: 'warning'
  },
  5: {
    label: 'Disetujui',
    color: 'success'
  },
  6: {
    label: 'Ditolak',
    color: 'red'
  },
  8: {
    label: 'Dibatalkan',
    color: 'red'
  },
  9: {
    label: 'Dibatalkan Oleh Sistem',
    color: 'red'
  },
}

export default {
    STATUS_AKTIF,
    STATUS_NONAKTIF,
    STATUS_PENDING,
    STATUS_REJECT,
    STATUS_BLOKIR,
    STATUS_AJUAN,
}
